import { Box, em, Flex, Image, Skeleton, Text, Title } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { Fragment, useEffect } from 'react'
import ProductInfoSkeleton from '../../../components/skeletons/ProductInfoSkeleton.tsx'
import { getAllFavouriteProductsAction } from '../../../store/product/productActions.ts'
import { useAppDispatch, useAppSelector } from '../../../store/store.ts'
import ProductCardNew from './ProductCardNew.tsx'

const FavouriteProducts = () => {
	const dispatch = useAppDispatch()
	const isSmall = useMediaQuery(`(max-width: ${em(768)})`)
	const { favouriteProducts, loaders } = useAppSelector(
		(state) => state.product
	)
	useEffect(() => {
		dispatch(getAllFavouriteProductsAction())
	}, [])
	return (
		<>
			{favouriteProducts?.favorites?.length === 0 ? (
				<Flex
					w='100%'
					h='80vh'
					direction='column'
					justify='center'
					align='center'
					my='xl'
					py='xl'
				>
					<Box h={200} w={200}>
						<Image
							h={190}
							w={190}
							src='https://res.cloudinary.com/dhl8hhlsx/image/upload/v1724749741/Empty%20Screens/tqkbyzy8ls2dkdk5eovr.png'
						/>
					</Box>
					<Text>
						Add products to <span style={{ color: '#62BE12' }}>Wishlist!</span>
					</Text>
				</Flex>
			) : (
				<Flex justify='center' align='center' p='sm'>
					<Flex
						direction='column'
						w={isSmall ? '100%' : 1240}
						maw={isSmall ? '100%' : 1240}
					>
						{loaders.gettingAllFavouriteProducts ? (
							<Flex w={'100%'} my={10} justify={'center'} align={'center'}>
								<Skeleton height={35} radius='md' animate />
							</Flex>
						) : (
							<Title order={3}>My Wishlist</Title>
						)}

						<Flex wrap='wrap' justify={isSmall ? 'center' : ''}>
							{loaders.gettingAllFavouriteProducts ? (
								<ProductInfoSkeleton />
							) : (
								<Fragment>
									{favouriteProducts?.favorites?.map((product, index) => {
										return (
											<ProductCardNew
												key={index}
												product={product}
												favourite={true}
											/>
										)
									})}
								</Fragment>
							)}
						</Flex>
					</Flex>
				</Flex>
			)}
		</>
	)
}

export default FavouriteProducts
